import moment from "moment";

export const initialValues = () => ({
  description: "",
  reportId: "",
  embedUrl: "",
  day: moment(),
  department: [],
});
